// assets
import { IconReport  } from '@tabler/icons';

// constant
const icons = {
    IconReport 
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const reports = {
    id: 'reports',
    type: 'group',
    children: [
        {
            id: 'reports',
            title: 'Reports',
            type: 'collapse',
            icon: icons.IconReport ,
            children: [
                {
                    id: 'leagues',
                    title: 'League List',
                    type: 'item',
                    url: '/reports/leagues',
                    breadcrumbs: true
                },
                {
                    id: 'teams',
                    title: 'Team List',
                    type: 'item',
                    url: '/reports/teams',
                    breadcrumbs: true
                },
                {
                    id: 'matchResult',
                    title: 'Match Result',
                    type: 'item',
                    url: '/reports/matchResult',
                    breadcrumbs: true
                },
                {
                    id: 'parlayReport',
                    title: 'Parlay Report',
                    type: 'item',
                    url: '/reports/parlayReport',
                    breadcrumbs: false
                },
                {
                    id: 'bodyReport',
                    title: 'Body Report',
                    type: 'item',
                    url: '/reports/bodyReport',
                    breadcrumbs: false
                },
                {
                    id: 'memberLimits',
                    title: 'Member Limits',
                    type: 'item',
                    url: '/reports/memberLimits',
                    breadcrumbs: true
                },

                // {
                //     id: 'win/lose',
                //     title: 'Win/Lose',
                //     type: 'item',
                //     url: '/icons/tabler-icons',
                //     breadcrumbs: false
                // },
                // {
                //     id: 'memberOutstanding',
                //     title: 'Member Outstanding',
                //     type: 'item',
                //     url: '/icons/material-icons',
                //     breadcrumbs: false
                // },
                {
                    id: 'statement',
                    title: 'Transactions',
                    type: 'item',
                    url: '/reports/statement',
                    breadcrumbs: true
                },
                {
                    id: 'twoThreeSettle',
                    title: '2D/3D Settle',
                    type: 'item',
                    url: '/reports/twoThreeSettle',
                    breadcrumbs: true
                },
                {
                    id: 'winners',
                    title: 'Winners',
                    type: 'item',
                    url: '/reports/winners',
                    breadcrumbs: false
                },
                {
                    id: 'twoThreeStatements',
                    title: '2D/3D စာရင်း',
                    type: 'item',
                    url: '/reports/twoThreeStatements',
                    breadcrumbs: false
                },
                // {
                //     id: 'paymentAndTransferHistory',
                //     title: 'Payment & Transfer History',
                //     type: 'item',
                //     url: '/icons/material-icons',
                //     breadcrumbs: false
                // },
                // {
                //     id: 'matchResult',
                //     title: 'Match Result',
                //     type: 'item',
                //     url: '/icons/material-icons',
                //     breadcrumbs: false
                // }
            ]
        }
    ]
};

export default reports;
